<template>
  <div class="space-y-3 pb-6">
    <!-- Page Header -->
    <div>
      <h2 class="text-lg font-bold text-gray-800">Tertiary Structure</h2>
      <p class="text-xs text-gray-500 mt-0.5">Set up your institution's faculties, departments, programmes, and modules</p>
    </div>

    <div class="rounded-lg border border-primary/20 bg-primary/5 p-3 text-sm text-gray-700">
      <div class="flex items-start gap-2">
        <i class="pi pi-info-circle mt-0.5 text-primary"></i>
        <div>
          <p class="font-semibold text-gray-800">How to use this section</p>
          <p class="mt-1 text-xs text-gray-600">Create faculties first, then departments, then programmes. The batch queue helps you add several records quickly without losing context.</p>
        </div>
      </div>
    </div>

    <!-- Step Indicators -->
    <div class="flex items-center gap-1.5">
      <button
        v-for="(step, idx) in steps"
        :key="step.name"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-xs font-medium transition-all border"
        :class="activeStep === step.name
          ? 'bg-primary text-white border-primary shadow-sm'
          : 'bg-white text-gray-600 border-gray-300 hover:bg-gray-50'"
        @click="activeStep = step.name"
      >
        <span
          class="inline-flex items-center justify-center w-5 h-5 rounded-full text-xs font-bold"
          :class="activeStep === step.name ? 'bg-white text-primary' : 'bg-gray-200 text-gray-600'"
        >{{ idx + 1 }}</span>
        {{ step.label }}
      </button>
    </div>

    <!-- Content -->
    <CreateFaculty v-if="activeStep === STEP_FACULTIES" />
    <CreateDepartment v-if="activeStep === STEP_DEPARTMENTS" />
    <CreateProgramme v-if="activeStep === STEP_PROGRAMMES" />
    <CreateModule v-if="activeStep === STEP_MODULES" />
  </div>
</template>

<script setup lang="ts">
import CreateFaculty from './TertiaryBoard/CreateFaculty.vue';
import CreateDepartment from './TertiaryBoard/CreateDepartment.vue';
import CreateProgramme from './TertiaryBoard/CreateProgramme.vue';
import CreateModule from './TertiaryBoard/CreateModule.vue';
import { TERTIARY_STEPS, STEP_FACULTIES, STEP_DEPARTMENTS, STEP_PROGRAMMES, STEP_MODULES } from './constants';

const steps = TERTIARY_STEPS;
const activeStep = ref(STEP_FACULTIES);
</script>
